var UTILS = require("../libs/utils.js");
const itemTypes = require("./itemTypes.js");
const skins = require("./skins.js");
module.exports.wheels = [{
  name: "Starter",
  language: "windows.store.spin.type.starter",
  primary: true,
  headCol: "#b2f252",
  price: 50,
  icons: 2,
  rarities: [75, 22, 3, 0, 0, 0],
  buttonColor: "#BFF06C",
  multi: 10,
  ticketIndex: 6423
}, {
  name: "Elite",
  language: "windows.store.spin.type.elite",
  primary: true,
  headCol: "#2196F3",
  price: 100,
  icons: 3,
  rarities: [50, 30, 15, 5, 0, 0],
  buttonColor: "#4994EC",
  multi: 10,
  ticketIndex: 6424
}, {
  name: "Heroic",
  language: "windows.store.spin.type.heroic",
  primary: true,
  headCol: "#fc9803",
  price: 500,
  icons: 4,
  bigRar: 5,
  rarities: [0, 48, 35, 14, 2.49, 0.5, 0.01],
  buttonColor: "#EE9D38",
  multi: 10,
  ticketIndex: 6425
}, {
  name: "Ultra",
  language: "windows.store.spin.type.ultra",
  headCol: "#ed4242",
  icons: 4,
  bigRar: 5,
  rarities: [0, 28, 53, 13.5, 4.45, 1, 0.05],
  buttonColor: "#EE9D38",
  ticketIndex: 6426,
  ticketOnly: true
}, {
  name: "Free KR",
  language: "windows.store.spin.type.freeKR",
  headCol: "#00bcd4",
  free: true,
  kr: true,
  hideMobile: true,
  minLvl: 1,
  price: 0,
  priceT: "Claim",
  priceCol: "#00eaff",
  adjRars: true,
  icons: 0,
  rarities: [50, 39, 10, 1, 0, 0],
  buttonColor: "#54b9d1"
}];
module.exports.promos = {
  YENDIS: {
    name: "GamerSupps",
    headCol: "#5f269f",
    icon: 0
  },
  GAMERSUPPS: {
    name: "GamerSupps",
    headCol: "#5f269f",
    icon: 0
  }
};
module.exports.tags = {
  Debug: "#000000",
  Easter: null,
  Twitch: "#6441a5",
  "Clan Wars": null,
  Charity: "#6441a5",
  Raid: "#eb347a",
  Canteen: "#fe4002",
  Gift: null,
  Free: null,
  Christmas: null,
  Burg: "#ADE4F9",
  Sandstorm: "#ADE4F9",
  Littletown: "#ADE4F9",
  Site: "#ADE4F9",
  Industry: "#ADE4F9",
  Subzero: "#ADE4F9",
  Freight: "#ADE4F9",
  Undergrowth: "#ADE4F9",
  Lostworld: "#ADE4F9",
  Kanji: "#ADE4F9",
  Citadel: "#ADE4F9",
  Oasis: "#ADE4F9",
  Evacuation: "#ADE4F9",
  Craftable: "#cc51f8",
  NFT: "#f3b8ff",
  Ranked: "#ff5500",
  FRVR: "linear-gradient(132deg, rgba(0,189,255,1) 0%, rgba(155,0,255,1) 25%, rgba(255,0,41,1) 50%, rgba(255,150,3,1) 75%, rgba(255,199,0,1) 100%)",
  Halloween: "#ff5500"
};
module.exports.types = ["weapons/weapon_", "hats/hat_", "body/body_", "melee/melee_", "sprays/", "dyes/", "waist/waist_", "faces/face_", "shoes/shoe_", "pets/pet_", "collectibles/collect_", "wrist/wrist_", "charms/charm_", "tickets/ticket_", "back/back_", "head/head_", "playercards/card_"];
module.exports.purchases = [{
  val: 300,
  priceSale: 0.89,
  price: 0.99,
  priceSteam: 1.15,
  priceSteamSale: 0.99,
  col: "#888888",
  productId: "ch.yendis.krunkerhub.kr300"
}, {
  val: 600,
  priceSale: 1.61,
  price: 1.79,
  priceSteam: 2.05,
  priceSteamSale: 1.85,
  col: "#b2f251",
  productId: "ch.yendis.krunkerhub.kr600"
}, {
  val: 2600,
  priceSale: 6.74,
  price: 7.49,
  priceSteam: 8.99,
  priceSteamSale: 7.99,
  col: "#3696f3",
  productId: "ch.yendis.krunkerhub.kr2600"
}, {
  val: 7000,
  priceSale: 14.39,
  price: 15.99,
  priceSteam: 18.49,
  priceSteamSale: 16.49,
  col: "#e040fb",
  productId: "ch.yendis.krunkerhub.kr7000"
}, {
  val: 20000,
  priceSale: 31.49,
  price: 34.99,
  priceSteam: 40.49,
  priceSteamSale: 36.49,
  tag: "Popular!",
  tagCol: "#ed4242",
  col: "#fa9704",
  productId: "ch.yendis.krunkerhub.kr20000"
}, {
  val: 60000,
  priceSale: 89.99,
  price: 99.99,
  priceSteam: 114.99,
  priceSteamSale: 103.49,
  tag: "Best Value!",
  tagCol: "#E040FB",
  col: "#ee5356",
  productId: "ch.yendis.krunkerhub.kr60000"
}];
module.exports.mobilePurchases = [{
  val: 300,
  price: 0.99,
  productId: "ch.yendis.krunkerhub.kr300"
}, {
  val: 600,
  price: 1.79,
  blackFriday: {
    val: 630,
    pct: 5
  },
  productId: "ch.yendis.krunkerhub.kr600"
}, {
  val: 2600,
  price: 7.49,
  blackFriday: {
    val: 2860,
    pct: 10
  },
  productId: "ch.yendis.krunkerhub.kr2600"
}, {
  val: 7000,
  price: 15.99,
  blackFriday: {
    val: 8050,
    pct: 15
  },
  productId: "ch.yendis.krunkerhub.kr7000"
}, {
  val: 20000,
  price: 34.99,
  blackFriday: {
    val: 26000,
    pct: 30
  },
  productId: "ch.yendis.krunkerhub.kr20000",
  tag: "Popular!",
  tagCol: "#ed4242"
}, {
  val: 60000,
  price: 99.99,
  blackFriday: {
    val: 90000,
    pct: 50
  },
  productId: "ch.yendis.krunkerhub.kr60000",
  tag: "Best Value!",
  tagCol: "#E040FB"
}];
module.exports.premium = [{
  val: 7,
  price: 1.49,
  tag: "Starter",
  tagCol: "#42ed56",
  headCol: "#a1f326"
}, {
  val: 30,
  price: 4.99,
  tag: "Popular!",
  tagCol: "#ed4242",
  headCol: "#2196F3"
}, {
  val: 60,
  price: 8.99,
  headCol: "#E040FB"
}, {
  val: 90,
  price: 12.99,
  tag: "Best Value!",
  tagCol: "#E040FB",
  headCol: "#fc9803"
}];
module.exports.lootRars = [0, 0, 70.395, 25.49, 4, 0.105, 0.01];
module.exports.rarities = [{
  name: "Uncommon",
  language: "windows.spin.rarity.uncommon",
  rar: 60,
  color: "#b2f252",
  confC: 30,
  confCols: ["#b2f252", "#fff"],
  sell: 1,
  fee: 5
}, {
  name: "Rare",
  language: "windows.spin.rarity.rare",
  rar: 40,
  color: "#2196F3",
  confC: 30,
  confCols: ["#2196F3", "#fff"],
  sell: 3,
  fee: 5
}, {
  name: "Epic",
  language: "windows.spin.rarity.epic",
  rar: 25,
  color: "#E040FB",
  confC: 30,
  confCols: ["#E040FB", "#fff"],
  sell: 10,
  fee: 5
}, {
  name: "Legendary",
  language: "windows.spin.rarity.legendary",
  rar: 10,
  color: "#FBC02D",
  confC: 40,
  confCols: ["#FBC02D", "#fff"],
  sell: 100,
  fee: 10
}, {
  name: "Relic",
  language: "windows.spin.rarity.relic",
  rar: 2.5,
  color: "#ed4242",
  confC: 50,
  confCols: ["#ed4242", "#fff"],
  sell: 500,
  fee: 10
}, {
  name: "Contraband",
  language: "windows.spin.rarity.contraband",
  rar: 0.5,
  color: "#292929",
  confC: 70,
  confCols: ["#292929", "#fff"],
  sell: 2500,
  fee: 25,
  scrap: 5
}, {
  name: "Unobtainable",
  language: "windows.spin.rarity.unobtainable",
  rar: 0,
  color: "#fff53d",
  confC: 100,
  confCols: ["#ff0000", "#ffa500", "#ffff00", "#008000", "#0000ff", "#4b0082", "#ee82ee"],
  animate: true,
  sell: 10000,
  fee: 200,
  scrap: 50
}, {
  name: "NFT",
  language: "windows.spin.rarity.nft",
  rar: 0,
  color: "#f3b8ff",
  confC: 0,
  confCols: ["#f3b8ff", "#fff"],
  sell: 10,
  fee: 500,
  noSpin: true
}];
module.exports.checkReq = function (p5084, p5085) {
  if (!p5084) {
    return false;
  }
  if (p5084.req == "accAge") {
    var v4508 = p5084.reqAmount;
    return p5085 && new Date().getTime() - new Date(p5085.createDate).getTime() >= v4508;
  }
  if (p5084.req == "stats") {
    return p5085 && p5085.stats && (p5085.stats[p5084.reqVar] || 0) >= p5084.reqAmount;
  } else {
    return p5084.req == "accVar" && p5085 && (p5085[p5084.reqVar] || 0) >= p5084.reqAmount;
  }
};
module.exports.getSpnItems = function (p5086, p5087, p5088, p5089, p5090) {
  p5087 = p5087 || 0;
  var vA238 = [];
  var v4509 = p5086.itemTypes;
  var v4510 = p5086.limGroup;
  var v4511 = p5086.limType;
  var v4512 = p5086.itemIndexs;
  var v4513 = p5086.weaponType;
  for (var vLN0709 = 0; vLN0709 < module.exports.skins.length; ++vLN0709) {
    if (!!module.exports.skins[vLN0709] && !module.exports.skins[vLN0709].limited && !module.exports.skins[vLN0709].blocked && !module.exports.skins[vLN0709].noSpin && !module.exports.skins[vLN0709].blackM && !module.exports.skins[vLN0709].opensea && (module.exports.skins[vLN0709].rarity == p5087 || !!p5090 && !!(module.exports.skins[vLN0709].rarity >= p5090)) && (!v4511 || v4511 == module.exports.skins[vLN0709].limT) && (!!v4511 || !module.exports.skins[vLN0709].limT) && (!v4510 || v4510 == module.exports.skins[vLN0709].limG) && (!!v4510 || !module.exports.skins[vLN0709].limG) && (!v4509 || !(v4509.indexOf(module.exports.skins[vLN0709].type || 0) < 0)) && (!v4512 || !(v4512.indexOf(vLN0709) < 0)) && (!module.exports.skins[vLN0709].req || !!module.exports.checkReq(module.exports.skins[vLN0709], p5088)) && (!!module.exports.skins[vLN0709].mSeas || (module.exports.skins[vLN0709].seas || 1) == p5089) && (v4513 == null || v4513 == module.exports.skins[vLN0709].weapon)) {
      vA238.push(vLN0709);
    }
  }
  return vA238;
};
module.exports.calcTradeFee = function (p5091, p5092) {
  if (p5092 && p5092.premiumT > 0) {
    return 0;
  }
  var v4514;
  var vLN0711 = 0;
  for (var vLN0712 = 0; vLN0712 < p5091.length; ++vLN0712) {
    v4514 = module.exports.skins[p5091[vLN0712]];
    if (v4514) {
      vLN0711 += module.exports.rarities[v4514.rarity].fee || 0;
    }
  }
  return vLN0711;
};
module.exports.getFreeKR = function (p5093) {
  return {
    kr: module.exports.freeKR[p5093].kr[0],
    rarity: module.exports.freeKR[p5093].rarity
  };
};
module.exports.freeKR = [{
  kr: [5],
  rarity: 0
}, {
  kr: [10],
  rarity: 1
}, {
  kr: [20],
  rarity: 2
}, {
  kr: [500],
  rarity: 3
}];
module.exports.previews = {
  1: {
    xOff: -2,
    yOff: -2.6,
    zRota: 0.2,
    scl: 0.001376794727638135
  },
  2: {
    xOff: -1.4,
    yOff: -0.8,
    scl: 0.001148941748743716
  },
  3: {
    xOff: 0,
    yOff: -0.2,
    scl: 0.000676917226130652
  },
  4: {
    xOff: -1.5,
    yOff: 0.5,
    scl: 0.000940741507537686
  },
  5: {
    xOff: -0.8,
    yOff: 0.5,
    scl: 0.00079312502512562
  },
  6: {
    xOff: -1,
    yOff: -1.1,
    scl: 1.2
  },
  7: {
    xOff: -1,
    yOff: -0.9,
    scl: 0.001221518472361808
  },
  8: {
    xOff: -1,
    yOff: -0.6,
    scl: 0.0012179208743718641
  },
  9: {
    xOff: -1.2,
    yOff: -1,
    scl: 0.0010676876984924638
  },
  10: {
    scl: 1.6
  },
  14: {
    yOff: -2.5,
    scl: 0.0007874150753768881
  },
  15: {
    scl: 0.00098426884422111
  },
  16: {
    scl: 1.4,
    yOff: 1,
    xOff: -1
  },
  17: {
    xOff: 0,
    yOff: -0.2,
    scl: 0.0003
  },
  19: {
    xOff: -1.4,
    yOff: -0.8,
    scl: 0.0009095788844221084
  },
  22: {
    xOff: 0,
    yOff: -0.2,
    scl: 0.0003158947055276376
  },
  24: {
    xOff: 0.7,
    yOff: -0.87,
    zOff: -3.33,
    scl: 0.0010531966030150732
  },
  25: {
    xOff: 0,
    yOff: 0,
    scl: 1
  },
  28: {
    xOff: 0,
    yOff: -0.2,
    scl: 0.000676917226130652
  },
  29: {
    xOff: -2,
    yOff: -2.6,
    zRota: 0.2,
    scl: 0.001376794727638135
  }
};
var vO122 = {};
var vA239 = [];
module.exports.templates = [{
  mid: 0,
  scl: 0.9,
  mScl: 1,
  zOff: 0.28,
  yOff: -0.5
}, {
  mid: 0,
  noMuz: true,
  spnScl: 1.3,
  scl: 0.9,
  mScl: 0.84,
  zOff: 0,
  yOff: 0
}, {
  flipAnim: true,
  id: 3,
  type: 3,
  scl: 2.6,
  sclMlt: 1,
  yOff: -1,
  xOff: -1.5,
  sxRot: 0.3,
  sxOff: 0.35,
  szOff: -0.25
}, {
  id: 0,
  type: 7,
  sitOff: 1,
  sitOffZ: 0.005,
  trans: true,
  yOff: -0.7,
  xOff: 1.6,
  xRot: -0.5
}];
module.exports.skins = skins;
for (var vLN0713 = 0; vLN0713 < module.exports.skins.length; vLN0713++) {
  module.exports.skins[vLN0713].index = vLN0713;
  module.exports.skins[vLN0713].seas = module.exports.skins[vLN0713].seas || 1;
  if (module.exports.skins[vLN0713].type == itemTypes.BACK) {
    module.exports.skins[vLN0713].assetType = 2;
    module.exports.skins[vLN0713].keyW = "Back";
  }
  if (module.exports.skins[vLN0713].type == itemTypes.HEAD) {
    module.exports.skins[vLN0713].assetType = 1;
    module.exports.skins[vLN0713].keyW = "Head";
  }
  if (module.exports.skins[vLN0713].creator) {
    var v4515 = module.exports.skins[vLN0713].creator.toLowerCase().split(", ");
    module.exports.skins[vLN0713].creators = v4515;
  }
  if (module.exports.skins[vLN0713].streamer) {
    var v4516 = module.exports.skins[vLN0713].streamer.toLowerCase().split(", ");
    module.exports.skins[vLN0713].streamers = v4516;
  }
  if (module.exports.skins[vLN0713].template != null) {
    var v4517 = module.exports.templates[module.exports.skins[vLN0713].template];
    for (var v4518 in v4517) {
      module.exports.skins[vLN0713][v4518] = v4517[v4518];
    }
  }
  if (module.exports.skins[vLN0713].free) {
    module.exports.skins[vLN0713].limT = "Free";
    module.exports.skins[vLN0713].noSale = true;
    module.exports.skins[vLN0713].noSpin = true;
  }
  if (module.exports.skins[vLN0713].itemShop) {
    module.exports.skins[vLN0713].noSale = module.exports.skins[vLN0713].itemShop == 1;
    module.exports.skins[vLN0713].noSpin = true;
    module.exports.skins[vLN0713].limited = true;
  }
  if (module.exports.skins[vLN0713].ranked) {
    module.exports.skins[vLN0713].noSale = true;
    module.exports.skins[vLN0713].noSpin = true;
    module.exports.skins[vLN0713].limited = true;
    module.exports.skins[vLN0713].noQuickSell = true;
    module.exports.skins[vLN0713].limT = "Ranked";
  }
  if (module.exports.skins[vLN0713].drop) {
    module.exports.skins[vLN0713].noSale = true;
    module.exports.skins[vLN0713].noQuickSell = true;
    if (!module.exports.skins[vLN0713].limT) {
      module.exports.skins[vLN0713].limT = "Twitch";
    }
  }
  if (module.exports.skins[vLN0713].mapReward != null) {
    module.exports.skins[vLN0713].noSpin = true;
    module.exports.skins[vLN0713].noSale = true;
    module.exports.skins[vLN0713].noQuickSell = true;
    if (!module.exports.skins[vLN0713].limT) {
      module.exports.skins[vLN0713].limT = "Map Reward";
    }
  }
  if (module.exports.skins[vLN0713].package) {
    module.exports.skins[vLN0713].noSpin = true;
    module.exports.skins[vLN0713].noQuickSell = true;
  }
  if (module.exports.skins[vLN0713].challenge) {
    module.exports.skins[vLN0713].noSale = true;
    module.exports.skins[vLN0713].noSpin = true;
    module.exports.skins[vLN0713].noQuickSell = true;
  }
  if (module.exports.skins[vLN0713].craftable) {
    module.exports.skins[vLN0713].noSale = true;
    module.exports.skins[vLN0713].noSpin = true;
    module.exports.skins[vLN0713].noQuickSell = true;
    module.exports.skins[vLN0713].limT = "Craftable";
  }
  if (module.exports.skins[vLN0713].bundle != null) {
    module.exports.skins[vLN0713].noSale = true;
    module.exports.skins[vLN0713].noSpin = true;
    module.exports.skins[vLN0713].noQuickSell = true;
    module.exports.skins[vLN0713].limT = "Bundle #" + (module.exports.skins[vLN0713].bundle || 0);
  }
  if (module.exports.skins[vLN0713].opensea) {
    module.exports.skins[vLN0713].noSpin = true;
    module.exports.skins[vLN0713].limT = "NFT";
  }
  if (module.exports.skins[vLN0713].type == itemTypes.COLLECTIBLE) {
    module.exports.skins[vLN0713].noSpin = true;
  }
  if (module.exports.skins[vLN0713].type == itemTypes.TICKET) {
    module.exports.skins[vLN0713].noSpin = true;
    module.exports.skins[vLN0713].side = 2;
  }
  if (module.exports.skins[vLN0713].battlepass) {
    module.exports.skins[vLN0713].limT = "Battle Pass";
    module.exports.skins[vLN0713].noSale = true;
    module.exports.skins[vLN0713].noSpin = true;
    module.exports.skins[vLN0713].noQuickSell = true;
  }
  if (module.exports.skins[vLN0713].type == itemTypes.PLAYER_CARD) {
    module.exports.skins[vLN0713].texExt = "webp";
  }
  if (module.exports.skins[vLN0713].limT && !module.exports.tags[module.exports.skins[vLN0713].limT]) {
    module.exports.tags[module.exports.skins[vLN0713].limT] = null;
  }
  module.exports.skins[vLN0713].thumbnail = UTILS.getPreview(module.exports.skins[vLN0713], module.exports);
}